import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClose = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 15 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.5312 16.3633C14.918 16.793 14.918 17.4375 14.5312 17.8242C14.1016 18.2539 13.457 18.2539 13.0703 17.8242L8 12.7109L2.88672 17.8242C2.45703 18.2539 1.8125 18.2539 1.42578 17.8242C0.996094 17.4375 0.996094 16.793 1.42578 16.3633L6.53906 11.25L1.42578 6.13672C0.996094 5.70703 0.996094 5.0625 1.42578 4.67578C1.8125 4.24609 2.45703 4.24609 2.84375 4.67578L8 9.83203L13.1133 4.71875C13.5 4.28906 14.1445 4.28906 14.5312 4.71875C14.9609 5.10547 14.9609 5.75 14.5312 6.17969L9.41797 11.25L14.5312 16.3633Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconClose);
export { ForwardRef as ReactComponent };
